import {
  Checkbox,
  FormControlLabel,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import InfiniteScroll from 'react-infinite-scroller';
import Iconify from '@/components/iconify/index.tsx';
import { LeaderboardItem } from '@/@types/api.types.ts';

type InfiniteTableProps = {
  checkedUsers: number[];
  data: LeaderboardItem[];
  hasMore: boolean;
  handleCheckUser: (checked: boolean, userId: number) => void;
  handleOpenMenu?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  loadMore: () => void;
};

export const InfiniteTable = ({
  checkedUsers,
  data,
  hasMore,
  handleCheckUser,
  handleOpenMenu,
  loadMore,
}: InfiniteTableProps) => {
  return (
    <InfiniteScroll
      pageStart={0}
      loadMore={loadMore}
      hasMore={hasMore}
      loader={
        <div className='loader' key='loader'>
          Loading ...
        </div>
      }
    >
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label='simple table'>
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>Rank</TableCell>
              <TableCell>User Id</TableCell>
              <TableCell>SSO User Id</TableCell>
              <TableCell>Title</TableCell>
              <TableCell>Points</TableCell>
              <TableCell align='right'></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, index) => (
              <TableRow
                key={index}
                sx={{
                  '&:last-child td, &:last-child th': { border: 0 },
                }}
              >
                <TableCell component='th' scope='row'>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={checkedUsers.includes(row.user_id)}
                        onChange={(event) =>
                          handleCheckUser(event.target.checked, row.user_id)
                        }
                      />
                    }
                    label=''
                  />
                </TableCell>
                <TableCell component='th' scope='row'>
                  {row.rank}
                </TableCell>
                <TableCell component='th' scope='row'>
                  {row.user_id}
                </TableCell>
                <TableCell component='th' scope='row'>
                  {row.sso_user_id}
                </TableCell>
                <TableCell component='th' scope='row'>
                  {row.username}
                </TableCell>
                <TableCell component='th' scope='row'>
                  {row.points}
                </TableCell>
                <TableCell component='th' scope='row' align='right'>
                  {handleOpenMenu && (
                    <IconButton
                      size='large'
                      color='inherit'
                      onClick={handleOpenMenu}
                      data-userid={row.user_id}
                    >
                      <Iconify icon={'eva:more-vertical-fill'} />
                    </IconButton>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </InfiniteScroll>
  );
};
